// https://www.youtube.com/watch?v=WbV3zRgpw_E&t=6960s
import React, { useState }  from 'react'
import Title from '../_title/Title'
// import Projects1 from './Projects1'
import CodingTraining1 from './CodingTraining1'
// import Projects3 from './Projects3'
// import Projects4 from './Projects4'




const CodingTrainingScreen = () => {
  return (
    <div>
      <div className="container">
        <Title title="."/>
        {/* <Title title=""/> */}
        <CodingTraining1/>  
      </div>
    </div>

  )
}

export default CodingTrainingScreen